/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Detail_Status_Subtitle_InactiveInputs */

const en_admin_company_detail_status_subtitle_inactive = /** @type {(inputs: Admin_Company_Detail_Status_Subtitle_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archived. Only visible on the admin dashboard with filter 'Inactive' or 'All'; job positions are hidden from candidates.`)
};

const de_admin_company_detail_status_subtitle_inactive = /** @type {(inputs: Admin_Company_Detail_Status_Subtitle_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archiviert. Wird auf dem Admin-Dashboard nur mit Filter „Inaktiv" oder „Alle" angezeigt; Stellen sind für Bewerber:innen ausgeblendet.`)
};

/**
* | output |
* | --- |
* | "Archived. Only visible on the admin dashboard with filter 'Inactive' or 'All'; job positions are hidden from candidates." |
*
* @param {Admin_Company_Detail_Status_Subtitle_InactiveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_company_detail_status_subtitle_inactive = /** @type {((inputs?: Admin_Company_Detail_Status_Subtitle_InactiveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Detail_Status_Subtitle_InactiveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_company_detail_status_subtitle_inactive(inputs)
	return en_admin_company_detail_status_subtitle_inactive(inputs)
});